let directive = function($compile, $timeout) {
    return {
        restrict: 'A',
        scope: {
            ngModel: '='
        },
        controller: function($scope, $element, $attrs) {

            var element = $element[0];

            //Parent element should be position:relative to make clear button in correct positon
            $element.parent().css( "position", "relative" );
            
            //Clear button icon class name
            $scope.buttonClass = 'ion-close';
            
            //ng-hide class used to fix init flash problem
            $scope.clearBtn = angular.element('<a tabindex="-1" ng-cloak class="ng-hide input-clear-btn button button-icon icon '+$scope.buttonClass+'" ng-click="clearInput()" ng-hide="fieldEmpty()"></a>');
            $compile($scope.clearBtn)($scope);
            $element.after($scope.clearBtn);
            
            $scope.clearInput = function () {
                $scope.ngModel = '';

                function preventBluring() {
                    element.focus();
                    $element.unbind( 'blur', preventBluring );
                }

                //keep focus on the field when click on the clear button
                $element.bind( 'blur' , preventBluring );
            };

            function refresh() {
                $timeout( function () {
                    $scope.$digest();
                });

            }

            $element.bind( 'focus', refresh );
            $element.bind( 'blur', refresh );

            $scope.fieldEmpty = function () {
                return (element.value == '' || element.value == null);
            }
        }
    }
};

export default directive;


// WEBPACK FOOTER //
// ./app/shared/directives/inputClear.directive.js